import { bugsnag } from '@/utils/bugsnag';
import { isProductionClient, isStagingClient } from '@/utils/helpers';

export function logError(msg: string, host?: string) {
  const { href, isProductionHref } = isProductionClient();
  const { isStagingHref } = isStagingClient();
  const formattedMsg = `${msg} (url: ${href || host})`;

  if (
    host === 'tap.az' ||
    host === 'ru.tap.az' ||
    host?.includes('azstaging.net') ||
    host?.includes('azstage.in') ||
    isProductionHref ||
    isStagingHref
  ) {
    bugsnag.notify(formattedMsg);
  }

  console.error(formattedMsg);
}
